import { ThemeType } from 'theme/jss-types';

export const getFontColorFromHSL = (hslString: string) => {
    if (typeof hslString !== 'string') {
        return 'black';
    }

    const hslRegex = /hsl\(\s*(\d+),\s*(\d+)%?,\s*(\d+)%?\s*\)/i;
    const match = hslString.match(hslRegex);

    if (!match) {
        throw new Error('Invalid HSL format');
    }

    const h = parseInt(match[1], 10);
    const s = parseInt(match[2], 10) / 100;
    const l = parseInt(match[3], 10) / 100;

    const c = (1 - Math.abs(2 * l - 1)) * s;
    const x = c * (1 - Math.abs(((h / 60) % 2) - 1));
    const m = l - c / 2;

    let r1 = 0;
    let g1 = 0;
    let b1 = 0;

    if (h < 60) {
        [r1, g1, b1] = [c, x, 0];
    } else if (h < 120) {
        [r1, g1, b1] = [x, c, 0];
    } else if (h < 180) {
        [r1, g1, b1] = [0, c, x];
    } else if (h < 240) {
        [r1, g1, b1] = [0, x, c];
    } else if (h < 300) {
        [r1, g1, b1] = [x, 0, c];
    } else {
        [r1, g1, b1] = [c, 0, x];
    }

    const r = Math.round((r1 + m) * 255);
    const g = Math.round((g1 + m) * 255);
    const b = Math.round((b1 + m) * 255);

    const brightness = (r * 299 + g * 587 + b * 114) / 1000;

    return brightness > 128 ? 'black' : 'white';
};

export const commonStyleSheet = (theme: ThemeType) => ({
    flexRow: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    flexColumn: {
        display: 'flex',
        flexDirection: 'column',
    },
    justifySpaceBetween: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    ellipses: {
        // add max width in the styles of the component using this
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    buttonStyle: {
        backgroundColor: theme.primaryColor,
        color: 'white',
        fontSize: '12px',
        fontWeight: '600',
        cursor: 'pointer',
    },
    header: {
        padding: 24,
        border: '1px solid #EFEFEF',
        borderRadius: 8,
        margin: 16,
    },
    fixedScrollbar: {
        '&::-webkit-scrollbar:vertical': {
            width: '11px',
        },
        '&::-webkit-scrollbar:horizontal': {
            height: '11px',
        },
        '&::-webkit-scrollbar-thumb': {
            borderRadius: '8px',
            border: '2px solid white',
            backgroundColor: 'rgba(0, 0, 0, .5)',
        },
        '&::-webkit-scrollbar': {
            WebkitAppearance: 'none',
            MozAppearance: 'none',
            appearance: 'none',
        },
    },
    anchor: {
        color: theme.primaryColor,
    },
    checkbox: {
        '& .ant-checkbox-checked .ant-checkbox-inner': {
            backgroundColor: theme.secondryColor,
            borderColor: theme.secondryColor,
        },
        '& .ant-checkbox + span': {
            width: '100%',
        },
    },
    addressName: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    footer: {
        marginTop: 100,
        position: 'fixed',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        bottom: 0,
        width: '100%',
        color: '#FFFFFF',
        height: 80,
        zIndex: 0,
        backgroundColor: '#052857',
    },
    buttons: {
        display: 'flex',
        marginTop: '20px',
        width: '90%',
        flexDirection: 'row',
        justifyContent: 'flex-end',
    },
    modal: {
        '& .ant-modal-body': {
            padding: 12,
        },
    },
    flexRowDiv: {
        display: 'flex',
        flexDirection: 'row',
    },
    icd: {
        float: 'right',
        fontSize: '9px',
        borderRadius: '4px',
        display: 'flex',
        alignContent: 'center',
        alignItems: 'center',
        alignSelf: 'center',
    },
    formItem: {
        '& .ant-form-explain': {
            fontSize: 10,
        },
    },
});
